import "./App.css";
import { useState, useEffect } from "react";
import { ThemeContext } from "./Helper/Context";
import Loader from "./components/Loader";
import Notification from "./components/Notification";
import Slots from "./components/Slots";
import LoginNotification from "./components/LoginNotification";
import Signin from "./components/Signin";
import Verifyemailcode from "./components/Verifyemailcode";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Enrolment from "./components/Enrolment";

function App() {
  const rootElm = document.getElementById("root");
  const url = rootElm.getAttribute("data-apiurl");
  const [showNotifcation, setShowNotification] = useState(true);
  const params = new URLSearchParams(window.location.search);
  const [showNotifcationLogin, setShowNotifcationLogin] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [showloader, setShowLoader] = useState(true);
  const [resetState, setResetState] = useState(false);
  const [mainState, setMainState] = useState({
    fetchURL: url + "/aapi/dynamic",
    isLoggedIn: false,
    isFirstLoad: true,
    showVerification: false,
    section: "landing",
    // section: 'signup',
    slots: true,
    children: [
      // {
      //   id:0,
      //   selected:false,
      //   firstName:'Karam Murad',
      //   lastName:'Ebrahim',
      //   birthDate:'01/01/1990',
      //   gender:'Male',
      //   phoneNumber:'+60122233521',
      //   email:'karam.murad@alyka.com.au',
      //   citizenship:'Yemeni',
      //   healthIssueDetails:'14 Avenue, 2203'
      // },
      // {
      //     id:1,
      //     selected:false,
      //     firstName:'Helmi Murad',
      //     lastName:'Ebrahim',
      //     birthDate:'01/01/1990',
      //     gender:'Male',
      //     phoneNumber:'+60122212521',
      //     email:'helmi.murad@alyka.com.au',
      //     citizenship:'Yemeni',
      //     healthIssueDetails:'14 Avenue, 2203'
      // },
    ],
  });
  // const [mainState, setMainState] = useState(
  //   {
  //     "fetchURL": "http://cockburnarc2020.alykatest.com.au/aapi/dynamic",
  //     "isLoggedIn": true,
  //     "showVerification": false,
  //     "section": "dashboard",
  //     "user": {
  //       "userId": 55860,
  //       "newUser": false,
  //       "firstName": "Alyka 3",
  //       "lastName": "tester",
  //       "sex": "Male",
  //       "email": "tester3@alyka.com.au",
  //       "birthdate": "1980-10-17T00:00:00+08:00",
  //       "phoneNumber": "101010600",
  //       "address": {
  //         "street": "Block A-11-03, Z Residence, Bukit Jalil",
  //         "additionalAddressLine": null,
  //         "postalCode": "58200",
  //         "city": null,
  //         "state": null,
  //         "country": "Australia",
  //         "memberId": 55860
  //       },
  //       "paymentSources": [
  //         {
  //           "paymentSource": "Cash",
  //           "publicData": "",
  //           "validTo": null,
  //           "memberId": 55860,
  //           "isDeleted": false,
  //           "version": 48880204,
  //           "id": 74137
  //         },
  //         {
  //           "paymentSource": "DirectDebit",
  //           "publicData": "22344",
  //           "validTo": null,
  //           "memberId": 55860,
  //           "isDeleted": false,
  //           "version": 48880309,
  //           "id": 74139
  //         }
  //       ]
  //     },
  //     "children": []
  //   }
  // )

  // window.scrollTo(0, 0)
  const [slotsState, setSlotsState] = useState({
    selectedSlot: null,
    slots: [
      {
        id: 33,
        day: "Monday",
        date: "29 March 2021",
      },
      {
        id: 34,
        day: "Tuesday",
        date: "30 March 2021",
      },
      {
        id: 35,
        day: "Wednesday",
        date: "31 March 2021",
      },
    ],
  });

  const handleUser = (id) => {
    mainState({
      ...mainState,
      userId: id,
      newUser: true,
    });

    setMainState({ ...mainState, section: "dashboard" });
  };

  // to be removed later
  // useEffect(() => {
  // if(showloader){
  //   setTimeout(() => {
  //     setShowLoader(false);
  //   }, 500);
  // }

  // },[showloader]);

  useEffect(() => {
    if (localStorage.getItem("childDetails") && localStorage.getItem("parentDetails")) {
      let slot = JSON.parse(localStorage.getItem("childDetails"));
      // params.delete('pgmPaymentId')
      setMainState({
        ...mainState,
        section: "enrolment",
        bookedSlot: slot,
      });
    } else {
      localStorage.removeItem("childDetails");
      localStorage.removeItem("parentDetails");
      // window.location.reload();
      // window.location.reload();
    }
  }, [mainState.isFirstLoad]);

  useEffect(() => {
    const ScrollToShowLoginNotification = (e) => {
      if (window.scrollY > 100 && !showNotifcationLogin) {
        setShowNotifcationLogin(true);
        window.removeEventListener("scroll", ScrollToShowLoginNotification);
      }
    };
    window.addEventListener("scroll", ScrollToShowLoginNotification);
  }, [showNotifcationLogin]);

  const showLoginNotification = (e) => {
    setShowNotifcationLogin(true);
  };

  const handleClickOutsidePopup = (e) => {
    // console.log(e.target.className)
    if (e.target.className.indexOf("perfectgym-popup") !== -1) {
      setShowSignin(false);
      setMainState({ ...mainState, showVerification: false });
      setSlotsState({ ...slotsState, selectedSlot: null });
    }
  };

  return (
    <div className="perfect-gym-app-wrapper">
      <ThemeContext.Provider
        value={{
          setShowNotifcationLogin,
          setShowNotification,
          setShowSignin,
          setShowLoader,
          mainState,
          setMainState,
          slotsState,
          setSlotsState,
          resetState,
          setResetState,
        }}
      >
        {showloader && <Loader />}
        {mainState.section === "landing" && (
          <>
            {showNotifcation && <Notification />}
            {!mainState.isLoggedIn && mainState.slots && (
              <>
                <div className="introtext">
                  <h2>Current lesson times</h2>
                  <p>
                    Current available class times for {params.get("Outcome")} are below. Before you begin enrolment,
                    please browse to ensure that there is a time available that suits you.
                  </p>
                  <p>
                    <b>You will actually select the class time further down the enrolment process.</b>
                  </p>
                  <p>Please begin by choosing to sign in or sign up.</p>
                </div>
              </>
            )}
            {!mainState.slots && (
              <>
                <div className="introtext">
                  <h2>No classes found!</h2>
                </div>
              </>
            )}
            {mainState.isLoggedIn && (
              <>
                <div className="introtext loggedin">
                  <h2>Select a class</h2>
                </div>
              </>
            )}
            {mainState.slots && !localStorage.getItem("childDetails") && (
              <Slots hidePopup={handleClickOutsidePopup} showLoginNotification={showLoginNotification} />
            )}
            {!mainState.isLoggedIn && showNotifcationLogin && <LoginNotification />}
            {showSignin && <Signin hidePopup={handleClickOutsidePopup} />}
            {mainState.showVerification && <Verifyemailcode hidePopup={handleClickOutsidePopup} />}
          </>
        )}

        {mainState.section === "signup" && <Signup onSubmit={handleUser} />}

        {mainState.section === "dashboard" && <Dashboard user={mainState.userId} />}

        {mainState.section === "enrolment" && <Enrolment hidePopup={handleClickOutsidePopup} />}
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
